export const getKeyByValue = (object, value) => Object.keys(object).find((key) => object[key] === value);
export const isObject = (object) => Object.prototype.toString.call(object) === '[object Object]';
//# sourceMappingURL=index.js.map